module.exports = __webpack_public_path__ + "img/right_4.c0fb3684.jpg";